// Mock data for portfolio

export const personalInfo = {
  name: "K R Pavan Tej",
  title: "Aspiring DevOps & Cloud Engineer",
  subtitle: "Building automated, scalable, and secure cloud infrastructure.",
  greeting: "Hello, I'm",
  description: "I specialize in cloud infrastructure, CI/CD automation, deployment pipelines, and multi-cloud environments. I work with AWS, Azure, and Google Cloud Platform, along with DevOps tools like Docker, Kubernetes, Terraform, and GitHub Actions. I'm passionate about building secure, reliable, and scalable systems that solve real-world engineering challenges.",
  email: "krpavantej013@outlook.com",
  location: "Bengaluru, India",
  phone: "+91 9*409777**",
  linkedin: "https://linkedin.com/in/krpavantej",
  github: "https://github.com/krpavantej",
  resume: "#"
};


export const aboutSection = {
  title: "I am K R Pavan Tej",
  greeting: "About Me",
  content: [
    "I am an aspiring Cloud & DevOps Engineer with hands-on experience across AWS, Azure, Google Cloud Platform, and Oracle Cloud. I'm passionate about building secure, automated, and scalable cloud infrastructure while continuously developing my skills in modern DevOps practices.",
    "I work with tools like Docker, Kubernetes, Terraform, Ansible, and GitHub Actions to build CI/CD pipelines and automate deployments. My foundation includes Linux administration, networking, cloud security basics, and infrastructure as code—enabling me to solve engineering challenges through automation and clean architecture.",
    "I've completed Google Cloud Arcade 2025 (Cohort 1 & 2), gaining practical experience with GCP labs covering Kubernetes Engine, Cloud Run, serverless functions, and cloud-native workflows. I also completed my Cloud Internship at Spy Agent (Apr–Jun 2025), contributing to cloud deployments, automation tasks, and DevOps workflows.",
    "I'm driven by curiosity, continuous learning, and the desire to build reliable systems that enhance developer productivity and support scalable, modern applications."
  ],
  highlights: [
    { label: "Education", value: "BE in Computer Science (Data Science)" },
    { label: "Experience", value: "Cloud Intern at Spy Agent (Apr–Jun 2025)" },
    { label: "Certifications", value: "Microsoft Azure · GitHub · Oracle (8x) · Salesforce" },
    { label: "Availability", value: "Full-time, Remote" }
  ],
  skills: {
    cloud: ["AWS", "Azure", "GCP", "Oracle Cloud"],
    devops: ["Docker", "Kubernetes", "Terraform", "Ansible", "GitHub Actions", "CI/CD"],
    other: ["Linux", "Monitoring", "IaC", "Cloud Security Basics"]
  },
  certifications: [
    "Microsoft Certified: Azure Fundamentals (AZ-900)",
    "Salesforce Agentforce Specialist",
    "GitHub Foundations Certification",
    "Oracle Cloud Certified (8x)",
    "Google Cloud Arcade 2025 – Cohort 1 & Cohort 2",
    "Google Cloud Fundamental Skills"
  ]
};

// Experience is now part of about section highlights

export const skillCards = [
  {
    id: 1,
    title: "Cloud Platforms",
    skills: [
      {
        name: "Amazon Web Services (AWS)",
        description: "EC2, S3, IAM basics, CloudWatch, VPC fundamentals",
        note: "Primary cloud platform"
      },
      {
        name: "Microsoft Azure",
        description: "Virtual Machines, Blob Storage, IAM, Resource Groups",
        note: ""
      },
      {
        name: "Google Cloud Platform (GCP)",
        description: "Compute Engine, Cloud Storage, IAM, Cloud Shell",
        note: "Google Cloud Arcade participant"
      }
    ]
  },
  {
    id: 2,
    title: "Operating Systems & Environment",
    skills: [
      {
        name: "Linux",
        description: "Ubuntu, basic system administration, shell navigation",
        note: ""
      },
      {
        name: "Windows Server",
        description: "Basic server management, PowerShell fundamentals",
        note: ""
      },
      {
        name: "Command Line Tools",
        description: "grep, find, curl, systemctl, basic networking commands",
        note: ""
      }
    ]
  },
  {
    id: 3,
    title: "Programming & Scripting",
    skills: [
      {
        name: "Python & Bash Scripting",
        description: "Automation scripts, basic system tasks, cloud automation",
        note: ""
      },
      {
        name: "Git & GitHub Version Control",
        description: "Version control, branching, pull requests, collaboration",
        note: "GitHub Foundations certified"
      },
      {
        name: "Laptop Hardware & Software Troubleshooting",
        description: "Hardware diagnostics, system repairs, software issues resolution",
        note: ""
      }
    ]
  },
  {
    id: 4,
    title: "Cloud & Infrastructure Skills",
    skills: [
      {
        name: "AWS Services",
        description: "EC2 (Virtual Machines), S3 (Object Storage), IAM (User & Role Management)",
        note: ""
      },
      {
        name: "Microsoft Azure",
        description: "Virtual Machines, Blob Storage, Resource Groups, IAM (Access Control)",
        note: ""
      },
      {
        name: "Google Cloud Platform",
        description: "Compute Engine, Cloud Storage, IAM (Permissions Management)",
        note: ""
      },
      {
        name: "Understanding Computer Hardware Specifications",
        description: "Hardware components, system requirements, performance optimization",
        note: ""
      }
    ]
  },
  {
    id: 5,
    title: "Additional Skills",
    skills: [
      {
        name: "Linux Basics & Troubleshooting",
        description: "Common file issues, system administration, debugging issues",
        note: ""
      },
      {
        name: "System Monitoring",
        description: "CloudWatch metrics, basic alerting, log viewing",
        note: ""
      },
      {
        name: "Documentation",
        description: "Technical writing, runbooks, README files, Markdown",
        note: ""
      }
    ]
  }
];


export const projects = [
  {
    id: 1,
    title: "Portfolio Website",
    description: "A professional portfolio website showcasing my cloud and DevOps expertise, certifications, and technical skills. Built with modern web technologies and featuring a responsive design, dark mode support, and smooth animations.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop&fm=webp&q=80",
    technologies: ["React", "TypeScript", "Tailwind CSS", "Vite"],
    github: "https://github.com",
    live: "https://portfolio.com"
  },
  {
    id: 2,
    title: "AWS Resource Tracker – DevOps Shell Scripting",
    subtitle: "DevOps Automation Project",
    description: "An automated AWS resource tracker built with Bash and AWS CLI. The script lists key AWS resources—EC2 instances, S3 buckets, and IAM users—and generates a structured report file that can be scheduled via cron. Designed to support cloud governance, cost control, and security audits in a lightweight, automation-friendly way.",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=600&fit=crop&fm=webp&q=80",
    technologies: ["AWS", "Bash", "AWS CLI", "Linux", "Cron Jobs", "DevOps", "Automation"],
    github: "https://github.com/krpavantej-dev/AWS-Resource-Tracker-DevOps-Shell-Scripting-Project",
    live: null
  }
];

export const certificationProviders = [
  {
    provider: "Microsoft Azure Certifications",
    icon: "cloud",
    certifications: [
      {
        title: "Microsoft Certified: Azure Fundamentals",
        issuer: "Microsoft",
        issuedOn: "Jan 2025",
        expiresOn: null,
        status: "Active",
        credentialId: "AZ-900",
        credentialImageUrl: "https://images.credly.com/size/340x340/images/be8fcaeb-c769-4858-b567-ffaaa73ce8cf/image.png",
        verificationUrl: "https://learn.microsoft.com/api/credentials/share/en-in/krpavantej-dev/F04026FB578180A1?sharingId=22F7CC54A508D64B"
      }
    ]
  },
  {
    provider: "GitHub Certifications",
    icon: "github",
    certifications: [
      {
        title: "GitHub Foundations",
        issuer: "GitHub",
        issuedOn: "Apr 2025",
        expiresOn: "Apr 2028",
        status: "Active",
        credentialId: "GitHub Foundations",
        credentialImageUrl: "https://images.credly.com/images/024d0122-724d-4c5a-bd83-cfe3c4b7a073/image.png",
        verificationUrl: "https://www.credly.com/badges/39d8958b-f481-420b-b52c-0adc15efbea1/public_url"
      }
    ]
  },
  {
    provider: "Salesforce Certifications",
    icon: "cloud",
    certifications: [
      {
        title: "Salesforce Certified Agentforce Specialist",
        issuer: "Salesforce",
        issuedOn: "May 2025",
        expiresOn: null,
        status: "Active",
        credentialId: "6162202",
        credentialImageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREi2tMMHtbFmhlui4NTXSzw3WaDxrwKzbu6Q&s",
        verificationUrl: "https://drive.google.com/file/d/1Uq2PkkuQ94og1vO3EJCu03hXfsmMoTp6/view?usp=sharing"
      }
    ]
  },
  {
    provider: "Oracle Certifications",
    icon: "cloud",
    certifications: [
      {
        title: "Oracle Cloud Infrastructure 2025 Certified Foundations Associate",
        issuer: "Oracle",
        issuedOn: "Apr 2025",
        expiresOn: "Apr 2027",
        status: "Active",
        credentialId: "1Z0-1122-25",
        credentialImageUrl: "https://education.oracle.com/file/general/Oracle_University_Generic_Badge_1202.png",
        verificationUrl: "https://drive.google.com/file/d/1-Q-FvQP_qWsghn9AsBP2is0zQku-FdXm/view?usp=sharing"
      },
      {
        title: "Oracle Cloud Infrastructure 2025 Certified AI Foundations Associate",
        issuer: "Oracle",
        issuedOn: "Feb 2024",
        expiresOn: "Feb 2025",
        status: "Active",
        credentialId: "1Z0-1122-25",
        credentialImageUrl: "https://education.oracle.com/file/general/Oracle_University_Generic_Badge_1202.png",
        verificationUrl: "https://drive.google.com/file/d/1-RfKr5UuhT9CvLi8VFYEshgmXnHSX9De/view?usp=sharing"
      },
      {
        title: "Oracle Data Platform 2025 Certified Foundations Associate",
        issuer: "Oracle",
        issuedOn: "Apr 2025",
        expiresOn: "Apr 2027",
        status: "Active",
        credentialId: "1Z0-1195-25",
        credentialImageUrl: "https://education.oracle.com/file/general/Oracle_University_Generic_Badge_1202.png",
        verificationUrl: "https://drive.google.com/file/d/1-LczFpi3bDlr1PSeRUk2dggqGdpImUFT/view?usp=sharing"
      },
      {
        title: "Oracle Fusion Cloud Applications CX Certified Foundations Associate",
        issuer: "Oracle",
        issuedOn: "May 2025",
        expiresOn: "May 2027",
        status: "Active",
        credentialId: "1Z0-1161-1",
        credentialImageUrl: "https://education.oracle.com/file/general/Oracle_University_Generic_Badge_1202.png",
        verificationUrl: "https://drive.google.com/file/d/1-FmSsxYHeuQ1v4ojrGeUfHXQ6_xs9qkF/view?usp=sharing"
      },
      {
        title: "Oracle Fusion Cloud Applications HCM Certified Foundations Associate",
        issuer: "Oracle",
        issuedOn: "May 2025",
        expiresOn: "May 2027",
        status: "Active",
        credentialId: "1Z0-1162-1",
        credentialImageUrl: "https://education.oracle.com/file/general/Oracle_University_Generic_Badge_1202.png",
        verificationUrl: "https://drive.google.com/file/d/1-93xafxbE0G7Tk5waXhhNHgUdM4Lc6IP/view?usp=sharing"
      },
      {
        title: "Oracle Fusion Cloud Applications SCM Foundations Associate",
        issuer: "Oracle",
        issuedOn: "May 2025",
        expiresOn: "May 2027",
        status: "Active",
        credentialId: "1Z0-1163-1",
        credentialImageUrl: "https://education.oracle.com/file/general/Oracle_University_Generic_Badge_1202.png",
        verificationUrl: "https://drive.google.com/file/d/1-7at11vZzT5wpUeAgRB_JvKNfZIRaug3/view?usp=sharing"
      },
      {
        title: "Oracle Fusion Cloud Applications ERP Certified Foundations Associate",
        issuer: "Oracle",
        issuedOn: "May 2025",
        expiresOn: "Apr 2027",
        status: "Active",
        credentialId: "1Z0-1160-1",
        credentialImageUrl: "https://education.oracle.com/file/general/Oracle_University_Generic_Badge_1202.png",
        verificationUrl: "https://drive.google.com/file/d/1-E-lZYdYVLZ-6dTPpxRPmLUEtKe8tJ_H/view?usp=sharing"
      },
      {
        title: "Oracle Cloud Infrastructure for Sunbird Ed Specialty",
        issuer: "Oracle",
        issuedOn: "May 2025",
        expiresOn: "May 2027",
        status: "Active",
        credentialId: "1Z0-1119-1",
        credentialImageUrl: "https://education.oracle.com/file/general/Oracle_University_Generic_Badge_1202.png",
        verificationUrl: "https://drive.google.com/file/d/1-PbAMFMY_28sA7EPWd6pJc6uTIsFAYkP/view?usp=sharing"
      }
    ]
  }
];

export const blogs = [
  {
    id: 1,
    title: "What is Docker, Containers, Dockerfile, and Docker Images?",
    excerpt: "Docker is a containerization platform that allows developers to break-free from the problems such as 'It works on my machine' syndrome...",
    thumbnail: "https://images.unsplash.com/photo-1605745341112-85968b19335b?w=800&h=400&fit=crop&fm=webp&q=80",
    author: {
      name: "K R Pavan Tej",
      avatar: "https://ui-avatars.com/api/?name=K+R+Pavan+Tej&background=06b6d4&color=fff&size=128",
      domain: "blog.krpavantej.tech"
    },
    publishedAt: "5 hours ago",
    tags: ["Docker", "DevOps", "Containers"],
    likes: 12,
    url: "https://hashnode.com/@krpavantej",
    platform: "Hashnode"
  },
  {
    id: 2,
    title: "Getting Started with AWS EC2: A Beginner's Guide",
    excerpt: "Learn the fundamentals of AWS EC2, how to launch your first instance, and understand key concepts like security groups and instance types...",
    thumbnail: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=400&fit=crop&fm=webp&q=80",
    author: {
      name: "K R Pavan Tej",
      avatar: "https://ui-avatars.com/api/?name=K+R+Pavan+Tej&background=06b6d4&color=fff&size=128",
      domain: "blog.krpavantej.tech"
    },
    publishedAt: "2 days ago",
    tags: ["AWS", "Cloud", "EC2"],
    likes: 28,
    url: "https://dev.to/krpavantej",
    platform: "Dev.to"
  },
  {
    id: 3,
    title: "Understanding CI/CD Pipelines with GitHub Actions",
    excerpt: "A comprehensive guide to setting up continuous integration and deployment pipelines using GitHub Actions for your cloud projects...",
    thumbnail: "https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=800&h=400&fit=crop&fm=webp&q=80",
    author: {
      name: "K R Pavan Tej",
      avatar: "https://ui-avatars.com/api/?name=K+R+Pavan+Tej&background=06b6d4&color=fff&size=128",
      domain: "blog.krpavantej.tech"
    },
    publishedAt: "1 week ago",
    tags: ["CI/CD", "GitHub", "DevOps"],
    likes: 45,
    url: "https://hashnode.com/@krpavantej",
    platform: "Hashnode"
  }
];
